import React, { ChangeEvent } from 'react';
import { Grid, useCheckPreview } from '@ts/storybook';
import { WrapperEntitySelector } from '@components/Inputs';
import { IMinAppProps } from '@interfaces/App.interface';
import { ICreateWarningRule } from '@ts/ui-models';

import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

interface WarningRuleStep2Props extends IMinAppProps {
  formData: any;
  setFormData: (attr: string) => (event: ChangeEvent | null, value: string | string[] | number | null) => void;
  requiredFields: string[];
  isPreview?: boolean;
}

const WarningRuleStep2: React.FC<WarningRuleStep2Props> = props => {
  const previewContent = useCheckPreview<ICreateWarningRule>(
    props.formData,
    ['assigneeId', 'userGroupId', 'distributionConfigurationId'],
    props.isPreview
  );

  if (previewContent) {
    return previewContent;
  }

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      {((props.formData.assigneeId && props.isPreview) || !props.isPreview) && (
        <Grid size={{ xs: 12, md: 8 }}>
          <WrapperEntitySelector
            label="ID of the assignee"
            value={props.formData.assigneeId}
            onChange={v => props.setFormData('assigneeId')(null, v)}
            isReadOnly={props.isPreview}
            searchComponent={generateSearchEntitySelector('user')}
            //infoText="Ayudaaa"
          />
        </Grid>
      )}
      {((props.formData.userGroupId && props.isPreview) || !props.isPreview) && (
        <Grid size={{ xs: 12, md: 8 }}>
          <WrapperEntitySelector
            label="ID of the user group"
            value={props.formData.userGroupId}
            onChange={v => props.setFormData('userGroupId')(null, v)}
            isReadOnly={props.isPreview}
            searchComponent={generateSearchEntitySelector('label')}
          />
        </Grid>
      )}
      {((props.formData.distributionConfigurationId && props.isPreview) || !props.isPreview) && (
        <Grid size={{ xs: 12, md: 8 }}>
          <WrapperEntitySelector
            label="ID of the distribution configuration"
            value={props.formData.distributionConfigurationId}
            onChange={v => props.setFormData('distributionConfigurationId')(null, v)}
            isReadOnly={props.isPreview}
            searchComponent={generateSearchEntitySelector('distributionConfiguration')}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default WarningRuleStep2;
